export default function handleGroupSelectData(raw) {
    if (Array.isArray(raw)) return raw;
    if (raw && typeof raw === "object") {
        return Object.keys(raw).flatMap((groupLabel) => {
            const arr = Array.isArray(raw[groupLabel]) ? raw[groupLabel] : [];
            return arr.map((item) => ({ ...item, group: groupLabel }));
        });
    }
}
